import { gql } from '@apollo/client';

export const OFFER_CANCELLED_STATES_PARAM_UPDATED = gql`
  subscription offerCancelledStatesBehaviorParamUpdated {
    offerCancelledStatesBehaviorParamUpdated
  }
`;
